/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Kb1Inputs */

const en_mk_cmp_clickup_kb1 = /** @type {(inputs: Mk_Cmp_Clickup_Kb1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent work quota is included in the seat price; there is no separate AI add-on.`)
};

const id_mk_cmp_clickup_kb1 = /** @type {(inputs: Mk_Cmp_Clickup_Kb1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota kerja agen termasuk di harga kursi; tidak ada add-on AI terpisah.`)
};

/**
* | output |
* | --- |
* | "Agent work quota is included in the seat price; there is no separate AI add-on." |
*
* @param {Mk_Cmp_Clickup_Kb1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_kb1 = /** @type {((inputs?: Mk_Cmp_Clickup_Kb1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Kb1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_kb1(inputs)
	return en_mk_cmp_clickup_kb1(inputs)
});